import DOMPurify from 'dompurify';

function LottoHeader (props) {
    let lotteryTicketNumbers = props.bootstrap;
    let current_state = props.state;

    const generateLoader = () => {
        return (
            <div className="loader">
                <div className="loading">
                </div>
            </div>
        );       
    }

    const get_draw_time = (current_state) => {
        let draw_time_arr = [];

        if (current_state.lotto_results.data.length > 0) {
            if (current_state.drawRemainingTime && current_state.drawRemainingTime.hasOwnProperty('days')) {
                draw_time_arr['days'] = current_state.drawRemainingTime.days ? current_state.drawRemainingTime.days : 0;
                draw_time_arr['hours'] = current_state.drawRemainingTime.hours ? current_state.drawRemainingTime.hours : 0;
                draw_time_arr['minutes'] = current_state.drawRemainingTime.minutes ? current_state.drawRemainingTime.minutes : 0;
                draw_time_arr['seconds'] = current_state.drawRemainingTime.minutes ? current_state.drawRemainingTime.seconds : 0;
            }
            else if (current_state.drawRemainingTime === 'DDAY') {
                draw_time_arr['days'] = 'D';
                draw_time_arr['hours'] = 'D';
                draw_time_arr['minutes'] = 'A';
                draw_time_arr['seconds'] = 'Y';
            }
        }

        return draw_time_arr;
    }

    let draw_map = get_draw_time(current_state);

    const t  = props.t;

    return (
        <div className="lotto-header">
            <div className="lotto-img">
                <img src={`/wp-content/uploads/2023/${current_state.current_lottery.image}`} alt="lotto logo" />
            </div>
            <div className="lotto-info">
                <p>{DOMPurify.sanitize(t(current_state.current_lottery.content))}</p>
                <div className="jackpot-amt">
                    <span className="local-amt">
                        {current_state.lotto_results.data.length > 0 
                            ? "€" + Number(current_state.lotto_results.data[0]?.jackpot?.total).toLocaleString() 
                            : generateLoader()}
                    </span>
                </div>
            </div>
            <div className="jackpot-time-mod">
                <time>
                    <>
                        <div className="time__display">
                            <span>{(draw_map['days'] === 'D' || draw_map['days'] >= 0)
                                ? (draw_map['days'])
                                : generateLoader()}
                            </span>
                            <span>{DOMPurify.sanitize(t("days"))}</span>
                        </div>
                        <div className="time__display">
                            <span>{(draw_map['hours'] === 'D' || draw_map['hours'] >= 0) 
                                ? (draw_map['hours']) 
                                : generateLoader()}
                            </span>
                            <span>{DOMPurify.sanitize(t('hrs'))}</span>
                        </div>
                        <div className="time__display">
                            <span>{(draw_map['minutes'] === 'A' || draw_map['minutes'] >= 0)
                                ? (draw_map['minutes']) 
                                : generateLoader()}
                            </span>
                            <span>{DOMPurify.sanitize(t('min'))}</span>
                        </div>
                        <div className="time__display">
                            <span>{(draw_map['seconds'] === 'Y' || draw_map['seconds'] >= 0)
                                ? (draw_map['seconds']) 
                                : generateLoader()}
                            </span>
                            <span>{DOMPurify.sanitize(t('sec'))}</span>
                        </div>
                    </>
                </time>
            </div>
        </div>        
    );
}
export default LottoHeader;